import { Stack, Box, TextField, Typography, Button } from "@mui/material";
import React, { useState } from "react";
import { useEffect } from "react";
import BodyPart from "../../../components/BodyPart";
import HorizontalScrollBar from "../../../components/HorizontalScrollBar";

const SearchExercises = ({
  setExercises,
  allExercises,
  bodyPart,
  bodyParts,
  search,
  setSearch,
}) => {
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (bodyPart === "all") {
      setExercises(allExercises);
      return;
    }

    const filteredExercises = allExercises.filter(
      (exercise) =>
        exercise.name.toLowerCase().includes(bodyPart) ||
        exercise.target.toLowerCase().includes(bodyPart) ||
        exercise.equipment.toLowerCase().includes(bodyPart) ||
        exercise.bodyPart.toLowerCase().includes(bodyPart)
    );

    setExercises(filteredExercises);
  }, [bodyPart, setExercises, allExercises]);

  const searchClickHandler = async () => {
    if (search) {
      setIsLoading(true);
      const filteredExercises = allExercises.filter(
        (exercise) =>
          exercise.name.toLowerCase().includes(search) ||
          exercise.target.toLowerCase().includes(search) ||
          exercise.equipment.toLowerCase().includes(search) ||
          exercise.bodyPart.toLowerCase().includes(search)
      );
      setExercises(filteredExercises);
      setSearch("");
      // console.log("Filtered exercises: ", filteredExercises);
      setIsLoading(false);
    }
  };
  return (
    <Stack
      sx={{
        alignItems: "center",
        mt: "37px",
        justifyContent: "center",
        padding: "20px",
      }}
    >
      <Typography
        sx={{
          fontWeight: 700,
          fontSize: { lg: "44px", xs: "30px" },
          mb: "50px",
          textAlign: "center",
        }}
      >
        Awesome Exercises You <br />
        Should Know
      </Typography>
      <Box sx={{ position: "relative", mb: "72px" }}>
        <TextField
          sx={{
            input: { fontWeight: 700, border: "none", borderRadius: "4px" },
            height: "76px",
            width: { lg: "1000px", xs: "350px" },
            backgroundColor: "#fff",
            borderRadius: "40px",
          }}
          value={search}
          onChange={(e) => setSearch(e.target.value.toLowerCase())}
          type="text"
          placeholder="Search Exercises..."
        />
        <Button
          variant="contained"
          color="error"
          sx={{
            backgroundColor: "#FF2625",
            color: "#fff",
            textTransform: "none",
            width: { lg: "175px", xs: "80px" },
            fontSize: { lg: "20px", xs: "14px" },
            height: "56px",
            position: "absolute",
            right: 0,
          }}
          onClick={searchClickHandler}
          disabled={isLoading}
        >
          {isLoading ? "Searching" : "Search"}
        </Button>
      </Box>

      <Box
        sx={{
          position: "relative",
          width: "100%",
          p: "20px",
        }}
      >
        <HorizontalScrollBar>
          {bodyParts.map((item) => <BodyPart key={item} item={item} bodyPart={bodyPart} />)}
        </HorizontalScrollBar>
      </Box>
    </Stack>
  );
};

export default SearchExercises;
